import { EMISSOR_BENEFITS_ONBOARDING_TOUR_CONFIG } from './emissorBenefitsOnboardingTourConfig';
export const MIGRATION_BENEFITS_ONBOARDING_TOUR_CONFIG = {
    ...EMISSOR_BENEFITS_ONBOARDING_TOUR_CONFIG,
    presentationVariant: 'migration',
    stepSelectors: EMISSOR_BENEFITS_ONBOARDING_TOUR_CONFIG.stepSelectors.map((selector, index) => index === 1 ? '[data-benefits-onboarding-anchor="migration-model-switch-highlight"]' : selector),
    translationKeyPrefix: 'benefits.migration.onboarding.tour',
    panelGapPx: Array.from({ length: 8 }, (_, index) => (index === 1 ? 21 : undefined)),
    panelHorizontalAlign: EMISSOR_BENEFITS_ONBOARDING_TOUR_CONFIG.panelHorizontalAlign.map((value, index) => {
        if (index === 1)
            return 'end';
        if (index === 7)
            return 'start';
        return value;
    }),
    arrowXMode: EMISSOR_BENEFITS_ONBOARDING_TOUR_CONFIG.arrowXMode.map((value, index) => index === 1 || index === 2 || index === 3 ? 'panel-end' : value),
    arrowPanelEndInsetPx: Array.from({ length: 8 }, (_, index) => (index === 3 ? 6 : undefined)),
    placementAnchorSelectors: Array.from({ length: 8 }, (_, index) => index === 7 ? '[data-benefits-onboarding-anchor="migration-shortcuts-group"]' : undefined),
};
